import { httpClient } from '../api/http.client';
import {
  Category,
  CategoriesResponse,
  UpdateCategoryDto,
} from '@/domain/entities';

export class CategoryRepository {
  async getAll(): Promise<CategoriesResponse> {
    return httpClient.get<CategoriesResponse>('/api/admin/categories');
  }

  async getById(id: number): Promise<Category> {
    return httpClient.get<Category>(`/api/admin/categories/${id}`);
  }

  async update(id: number, updates: UpdateCategoryDto): Promise<{ message: string }> {
    return httpClient.put<{ message: string }>(`/api/admin/categories/${id}`, updates);
  }

  async delete(id: number): Promise<void> {
    return httpClient.delete<void>(`/api/admin/categories/${id}`);
  }
}

export const categoryRepository = new CategoryRepository();

